import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: '404', pathMatch: 'full' },
  {
    path: '404',
    loadComponent: () => import('./page-not-found/page-not-found.component').then((c) => c.PageNotFoundComponent), // Assuming PageNotFoundComponent is now standalone
  },
  {
    path: 'embed',
    loadComponent: () => import('./vehicle/vehicle.component').then((c) => c.VehicleComponent), // Assuming VehicleComponent is now standalone
  },
  {
    path: 'trader/embed',
    loadComponent: () => import('./trader-vehicle/trader-vehicle.component').then((c) => c.TraderVehicleComponent), // Assuming TraderVehicleComponent is now standalone
  },
  {
    path: 'carbravo/embed',
    loadComponent: () => import('./vehicle/vehicle.component').then((c) => c.VehicleComponent), // Assuming VehicleComponent is reused as standalone
  },
  {
    path: 'widget',
    loadComponent: () => import('./widgetconfig/widgetconfig.component').then((c) => c.WidgetConfigComponent), // Assuming WidgetConfigComponent is now standalone
  },
  {
    path: 'reporting',
    loadChildren: () => import('./reporting/reporting.routes').then((r) => r.reportingRoutes),
  },
  {
    path: 'login',
    loadComponent: () => import('./login-dialog/login-dialog.component').then((c) => c.LoginDialogComponent), // Assuming LoginDialogComponent is now standalone
  },
  {
    path: 'viewemail/:country/:guid',
    loadComponent: () => import('./email-view/email-view.component').then((c) => c.EmailViewComponent), // Assuming EmailViewComponent is now standalone
  },
  {
    path: 'reviseoffer/:guid',
    loadComponent: () => import('./revise-lead/revise-lead.component').then((c) => c.ReviseLeadComponent), // Assuming ReviseLeadComponent is now standalone
  },
  { path: '**', redirectTo: '404', pathMatch: 'full' },
];
